import React from "react";
import PowerOfUseGoals from "../../../../components/shared/PowerOfUseGoals/PowerOfUseGoals";
import { formatPrice } from "../../../../../../utilities/formatPrice";
import localeText from "../../../../../../locale";

const EconomicCircleStatusCard = ({
  levelBadge,
  totalMembers,
  networkPower,
  activeInfluencePercent,
  extracoinPercent,
  userTypeInfo,
}) => (
  <div
    className="border-round-md p-3 h-full"
    style={{ border: "1px solid var(--theme-border, #EBEBEB)" }}
  >
    <div className="flex align-items-center gap-2 mb-2">
      <div
        className="text-xs font-semibold uppercase"
        style={{ color: "var(--theme-text-muted, #5C5C5C)" }}
      >
        {localeText("currentStatus") || "Status atual"}
      </div>
      <div
        className="inline-block px-2 border-round text-xs font-medium"
        style={{ color: "var(--theme-secondary)", border: "1px solid var(--theme-secondary)" }}
      >
        {String(levelBadge || "PARTNER").toUpperCase()}
      </div>
    </div>

    <div className="flex align-items-baseline gap-2 mb-1">
      <span className="text-5xl font-bold title" style={{ color: "var(--theme-primary)" }}>
        {totalMembers}
      </span>
      <span
        className="font-medium"
        style={{ color: "color-mix(in srgb, var(--theme-text) 50%, transparent)" }}
      >
        {localeText("members") || "Membros"}
      </span>
    </div>
    <div className="border-top-1 my-3" style={{ borderColor: "var(--theme-border)" }}></div>
    <div className="flex align-items-center">
      <div
        className="text-xs font-medium uppercase flex-1 text-center"
        style={{ color: "color-mix(in srgb, var(--theme-text) 50%, transparent)" }}
      >
        <div className="mb-1">{localeText("networkPowerVol") || "Poder de rede (VOL)"}</div>
        <div className="text-lg font-bold" style={{ color: "var(--theme-primary)" }}>
          {formatPrice(networkPower)} ECR
        </div>
      </div>
      <div
        style={{
          width: "1px",
          height: "3rem",
          background: "var(--theme-border, #e0e0e0)",
        }}
      />
      <div
        className="text-xs font-medium uppercase flex-1 text-center"
        style={{ color: "color-mix(in srgb, var(--theme-text) 50%, transparent)" }}
      >
        <div className="mb-1"> {localeText("activeInfluence") || "Influência ativa"}</div>
        <div className="text-lg font-bold" style={{ color: "var(--theme-primary)" }}>
          {activeInfluencePercent}%
        </div>
      </div>
    </div>
    <div className="border-top-1 my-3" style={{ borderColor: "var(--theme-border)" }}></div>

    <PowerOfUseGoals
      currentPercent={extracoinPercent}
      userTypeInfo={userTypeInfo}
      descriptionKey=""
    />
  </div>
);

export default EconomicCircleStatusCard;
